import PropTypes from 'prop-types';
import { forwardRef, memo } from 'react';
import { Icon } from '@iconify/react';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

const Iconify = memo(forwardRef(({ icon, width = 20, sx, 'aria-label': ariaLabel, ...other }, ref) => (
    <Box
        ref={ref}
        component={Icon}
        className="component-iconify"
        icon={icon}
        sx={{ width, height: width, ...sx }}
        aria-label={ariaLabel}
        aria-hidden={!ariaLabel}
        role={ariaLabel ? 'img' : 'presentation'}
        {...other}
    />
)));

Iconify.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    sx: PropTypes.object,
    width: PropTypes.number,
    'aria-label': PropTypes.string,
};

export default Iconify;
